import classNames from "classnames";
import InputWrapper from "../../../../components/Input/InputWrapper";

const Signature = ({settings = {}}) => {
    return (
        <InputWrapper className="signature">
            <span className="dots">................................</span>
            <label className={classNames({"required": settings.required})}>{settings.title}</label>
            {settings.description && <p className="description">{settings.description} </p>}
        </InputWrapper>
    )
};

export default Signature;